module.exports = __webpack_public_path__ + "media/images/emblems/Bischofszell-Blazono-bde754743efa71721ab8512ea0893a41.png";